import { render, staticRenderFns } from "./TratamientoAguaResidual.vue?vue&type=template&id=197ca45a&scoped=true&"
import script from "./TratamientoAguaResidual.vue?vue&type=script&lang=js&"
export * from "./TratamientoAguaResidual.vue?vue&type=script&lang=js&"
import style0 from "./TratamientoAguaResidual.vue?vue&type=style&index=0&id=197ca45a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "197ca45a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSpacer } from 'vuetify/lib/components/VGrid';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VCard,VCardText,VCol,VContainer,VRow,VSpacer,VTextField})
